<div class="spinner-container">
    <mat-spinner [diameter]="32" color="primary"></mat-spinner>
</div>
